
import { useEffect, useRef } from 'react';

function CoreOffer() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const cards = entry.target.querySelectorAll('.offer-card');
            cards.forEach((card, i) => {
              setTimeout(() => {
                card.classList.add('opacity-100', 'translate-y-0');
                card.classList.remove('opacity-0', 'translate-y-8');
              }, i * 150);
            });
          }
        });
      },
      { threshold: 0.15 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  const offers = [
    {
      image: 'https://public.readdy.ai/ai/img_res/d34ea03db794a43b3c456bbead8e8d8b.jpg',
      title: 'Intelligent Lead Capture',
      description: 'Never miss another opportunity. We build systems that capture, qualify, and route demand automatically.',
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Minimal%20abstract%203D%20render%20of%20interconnected%20flowing%20workflow%20paths%20and%20nodes%20on%20a%20dark%20charcoal%20surface%20with%20soft%20teal%20and%20cyan%20glow%2C%20clean%20geometric%20design%20representing%20structured%20automation%20architecture%2C%20premium%20tech%20visualization%20style%20like%20Apple%20marketing%20imagery%2C%20ultra%20clean%20composition&width=600&height=400&seq=offer-workflow-01&orientation=landscape',
      title: 'Workflow Architecture',
      description: 'Structured automations that eliminate manual friction and improve team efficiency across departments.',
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Minimal%20abstract%203D%20render%20of%20a%20clean%20holographic%20dashboard%20with%20floating%20data%20charts%20and%20KPI%20indicators%20on%20a%20dark%20charcoal%20surface%20with%20soft%20teal%20ambient%20glow%2C%20premium%20tech%20product%20visualization%20style%20like%20Apple%20marketing%20imagery%2C%20ultra%20clean%20geometric%20composition&width=600&height=400&seq=offer-perf-01&orientation=landscape',
      title: 'Performance Intelligence',
      description: 'Clear dashboards, measurable KPIs, and intelligent insights that support executive-level decisions.',
    },
  ];

  return (
    <section id="solutions" className="py-32" style={{ background: '#F5F5F7' }}>
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <p className="text-sm font-medium tracking-[0.2em] uppercase text-[#2DD4BF] mb-4">
            What We Build
          </p>
          <h2 className="text-4xl md:text-5xl font-semibold text-gray-900 tracking-tight">
            Core Solutions
          </h2>
        </div>

        <div ref={sectionRef} className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {offers.map((offer, index) => (
            <div
              key={index}
              className="offer-card opacity-0 translate-y-8 transition-all duration-700 ease-out bg-white rounded-2xl overflow-hidden hover:shadow-lg group cursor-pointer"
            >
              <div className="w-full h-52 overflow-hidden">
                <img
                  src={offer.image}
                  alt={offer.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className="p-8">
                <h3 className="text-lg font-semibold text-gray-900 mb-3">
                  {offer.title}
                </h3>
                <p className="text-sm text-gray-500 leading-relaxed font-light">
                  {offer.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default CoreOffer;
